import React from 'react';
import { Text } from '../../Text/Text';
import { getStoryId } from '../utils';
/**
 * @public
 */
export const StoryHeading = ({
  storyName,
  storyTitle
}) => React.createElement(Text, {
  id: getStoryId(storyName, storyTitle),
  textStyle: 'subheading3',
  my: 4
}, storyName);